export class KfmaoCode {
  public code1: number;
  public code2: number | null;
  public code3: number | null;
  public code4: number | null;
  public beschreibung: string;

  constructor(
    code1: number,
    code2: number | null,
    code3: number | null,
    code4: number | null,
    beschreibung: string
  ) {
    this.code1 = code1;
    this.code2 = code2;
    this.code3 = code3;
    this.code4 = code4;
    this.beschreibung = beschreibung;
  }
}
